import React from 'react';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import NavigationMoreVert from 'material-ui/svg-icons/navigation/more-vert';
import NavigationRefresh from 'material-ui/svg-icons/navigation/refresh';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import Toggle from 'material-ui/Toggle';

export default class SearchBar extends React.Component {
    state = {
        onlyEnabled: false
    };

    onlyEnabled = (event) => {
        this.setState({onlyEnabled: event.target.checked});
        this.props.onlyEnabled(event.target.checked);
    };

    render() {
        return (
            <div style={{display: 'flex'}}>
                <div style={{flexGrow: 1, overflow: 'hidden'}}>
                    <TextField style={{width: '100%'}}
                               hintText="Informe ID, nome, função ou recurso"
                               floatingLabelText="Filtrar tarefas"
                               floatingLabelFixed={true}
                               onChange={this.props.onTextChange}
                    />
                </div>
                <div style={{alignSelf: 'center'}}>
                    <IconMenu iconButtonElement={
                        <IconButton>
                            <NavigationMoreVert/>
                        </IconButton>
                    }>
                        <MenuItem primaryText="Atualizar" rightIcon={<NavigationRefresh />} onClick={this.props.onRefreshClick} />
                        <MenuItem style={{verticalAlign: 'middle'}}>
                            <Toggle label="Somente ativas" 
                                    style={{verticalAlign: 'middle', paddingTop: 12}}
                                    toggled={this.state.onlyEnabled}
                                    onToggle={this.onlyEnabled} />
                        </MenuItem>
                    </IconMenu>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/view/scheduler/list/SearchBar.js